import * as React from "react";
import LinkJuiceCategorySection from "./LinkJuiceCategorySection";
import { LinkJuiceProps } from "./typings";
import { InsideTabGroupContext } from "components/shared/InsideTabGroupContext/InsideTabGroupContext";
import { UitkHeading } from "uitk-react-text";
import { withStores } from "src/stores";
import { LinkJuiceFlexModuleResult } from "typings/microserviceModels/link-juice-flex-module";
import { LazyLoad } from "src/components/utility/LazyLoad/LazyLoad";
import { getFmId } from "src/stores/ExperienceTemplateStore";

const LinkJuice = (props: LinkJuiceProps) => {
  const { templateComponent, flexModuleModelStore, context } = props;

  if (!templateComponent || !flexModuleModelStore) {
    return null;
  }

  const { metadata, config } = templateComponent;
  const { id } = metadata;
  const { fmTitleId } = config;
  const fmId = getFmId(templateComponent);

  const model = flexModuleModelStore.getModel(id) as LinkJuiceFlexModuleResult | null;

  if (!model) {
    return null;
  }

  const { title, categories, collapsed, displayColumns } = model;

  if (!(title && categories && categories.length)) {
    return null;
  }

  const insideTabGroup = React.useContext(InsideTabGroupContext);
  const paddingTopClassName = insideTabGroup ? "" : " all-t-padding-three";

  return (
    <LazyLoad context={context}>
      <div
        className={`LinkJuice all-cell-1-1 uitk-cell${paddingTopClassName}`}
        id={id}
        data-fm={fmId}
        data-fm-title-id={fmTitleId}
      >
        {!insideTabGroup && (
          <div className="all-y-padding-three">
            <UitkHeading tag="h2" size={4}>
              {title}
            </UitkHeading>
          </div>
        )}
        {categories.map(
          (category) =>
            category.name && (
              <LinkJuiceCategorySection
                key={category.name}
                category={category}
                collapsed={collapsed || false}
                displayColumns={displayColumns}
              />
            )
        )}
      </div>
    </LazyLoad>
  );
};

export default withStores("flexModuleModelStore")(LinkJuice);
